import { ServicePageTemplate } from "@/components/ServicePageTemplate";

export default function Wohnungsaufloesung() {
  return (
    <ServicePageTemplate
      service={{
        title: "Wohnungsauflösung",
        keyword: "Wohnungsauflösung Berlin",
        metaTitle:
          "Wohnungsauflösung Berlin | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Stressfreie Wohnungsauflösung in Berlin. Wir übernehmen die komplette Räumung und besenreine Übergabe an den Vermieter.",
        heroSub:
          "Übergabefertige Räumung Ihrer Wohnung – ohne Stress und versteckte Kosten.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a181eb301d4357a32.jpg",
        trustImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a90167249909712123538.jpg",
        seoImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a967e20d627a9db4d.jpg",
        faqImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a109a1ab49dc13ffb.jpg",
        trustIntro:
          "Die Kündigungsfrist läuft, die Wohnung muss leer übergeben werden, und Sie wissen nicht, wo Sie anfangen sollen. Vielleicht wohnen Sie nicht einmal in Berlin. Wir übernehmen die komplette Wohnungsauflösung für Sie, damit die Übergabe an die Hausverwaltung reibungslos klappt.",
        slug: "wohnungsaufloesung-berlin",
        showOurWork: true,
      }}
    />
  );
}
